// features/rewardCategory/rewardCategorySlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchAllCategories } from '../features/adminAsync';

const initialState = { 
  category: [],
};

const rewardCategorySlice = createSlice({
  name: 'category',
  initialState,
  error:null,
  loading:false,
  category:[],
   reducers: {
    setCategory(state,action){
      state.category=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action) => {
        state.category = action.payload;
        state.loading = false;
      })
      .addCase(fetchAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCategory } = rewardCategorySlice.actions;
export default rewardCategorySlice.reducer;

